import { TextBlock } from '../schema';
import isEmptyParagraph from './is-empty-paragraph';

export default function stripTrailingEmptyParagraphs(blocks: Array<TextBlock>) {
  let end = blocks.length;
  while (end > 0 && isEmptyParagraph(blocks[end - 1])) {
    end--;
  }
  return end === blocks.length ? blocks : blocks.slice(0, end);
}
